import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface ReporterInfoFieldsProps {
  name: string | undefined;
  email: string | undefined;
}

export function ReporterInfoFields({ name, email }: ReporterInfoFieldsProps) {
  const { t } = useTranslation();

  return (
    <div className="grid gap-4 md:grid-cols-2">
      <div className="space-y-2">
        <Label htmlFor="reporterName">{t('forms.fullName')}</Label>
        <Input id="reporterName" value={name || ''} disabled className="bg-muted" />
      </div>
      <div className="space-y-2">
        <Label htmlFor="reporterEmail">{t('forms.email')}</Label>
        <Input id="reporterEmail" value={email || ''} disabled className="bg-muted" />
      </div>
    </div>
  );
}
